export class ApplicationStatusDTO {
  applicationStatusId: number;
  statusCode: string;
  statusName: string;
}
